import TLSServerCertificates from './TLSServerCertificates';
import reducer from './reducers';
import sagas from './sagas';

export default TLSServerCertificates;
export { reducer, sagas };
